import PrivacyPolicyBlock from 'components/Info/PrivacyPolicyBlock';

const PrivacyPolicyPage = () => {
  return <PrivacyPolicyBlock />;
};

export default PrivacyPolicyPage;
